import { render, staticRenderFns } from "./nulliefied_publication.vue?vue&type=template&id=afabbab6"
import script from "./nulliefied_publication.vue?vue&type=script&lang=js"
export * from "./nulliefied_publication.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports